import React from 'react';
import {SimpleDraftJsViewer} from "./simple-draft-js-viewer";

export function ViewDraftJsContent({content_state,text_only,compact,block_preview_count,block_count,classes='',style={fontSize:'16px',lineHeight:1.5}, ...rest}) {

    return <SimpleDraftJsViewer {...rest} text_only={text_only} compact={compact} block_preview_count={block_preview_count} block_count={block_count} classes={classes} style={style} viewer content_state={content_state} />
}